import React from 'react';
import { ArrowRight } from 'lucide-react';
import { Skeleton } from '@/components/ui/skeleton';
import { useNavigate } from 'react-router-dom';

interface StatCardProps {
  label: string;
  value: number | string;
  color: string;
  isLoading?: boolean;
  status?: string;
  isQuickFilter?: boolean;
}

export const StatCard: React.FC<StatCardProps> = ({
  label,
  value,
  color,
  isLoading = false,
  status,
  isQuickFilter = false,
}) => {
  const navigate = useNavigate();

  const handleClick = () => {
    if (status) {
      const param = isQuickFilter ? 'quick_filter' : 'status';
      navigate(`/submissions?${param}=${status}`);
    }
  };

  return (
    <div
      onClick={handleClick}
      className="flex-1 bg-white border border-[#e9eaeb] rounded-lg overflow-hidden transition-all cursor-pointer hover:shadow-md hover:border-gray-300 group"
    >
      <div className="h-1.5" style={{ backgroundColor: color }}></div>
      <div className="px-5 py-6 flex items-center justify-between h-[110px]">
        <div className="flex items-center gap-3">
          {isLoading ? (
            <Skeleton className="h-[36px] w-10" />
          ) : (
            <p className="text-3xl font-semibold text-[#181d27] tabular-nums leading-none min-w-[1.25rem]">
              {value}
            </p>
          )}
          <p className="text-sm text-[#535862] font-normal leading-tight text-left">{label}</p>
        </div>
        <ArrowRight className="w-4 h-4 text-gray-400 opacity-0 group-hover:opacity-100 transition-opacity flex-shrink-0" />
      </div>
    </div>
  );
};
